/* TODO: refactor file to change return type  */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { toast } from "react-toastify";

import {
  type TCreateTier,
  type TQRcode,
  type TUpdateTier,
} from "../config/types";
import { privateApi } from "./axiosInterceptor";
import { AxiosError } from "axios";

export const tierApi = {
  create: async (data: TCreateTier) => {
    return await privateApi.post("/tier", data, {}).then((r) => r.data);
  },
  update: async (data: TUpdateTier, id: number) => {
    return await privateApi.patch(`/tier/${id}`, data, {}).then((r) => r.data);
  },

  delete: async (id: number) => {
    return await privateApi.delete(`/tier/${id}`).then((r) => r.status);
  },
};

export const twoFactorAuth = {
  generateQRcode: async () => {
    return await privateApi
      .post("/2fa/generate")
      .then((r) => r.data as TQRcode)
      .catch((err) => {
        if (err instanceof AxiosError && err.response) {
          toast.error(`${err.response.statusText}`);
        }
      });
  },
};
